import { AuthMeUser } from '@common/types/user';
import { api } from '@services/api';

const authApi = api.injectEndpoints({
    endpoints: (builder) => ({
        authMe: builder.query<AuthMeUser, void>({
            query: () => 'auth/me',
            providesTags: ['User'],
        }),
    }),
});

export const { useAuthMeQuery, useLazyAuthMeQuery } = authApi;
export default authApi;
